import type { PurchaseConditionPrice } from '../../screens/Checkout/screens/Advertisements/types'

export const getPurchaseConditionPrice = (
  skuId: string | null,
  purchaseConditionsPricesBySimulation: PurchaseConditionPrice[] | undefined
): PurchaseConditionPrice | undefined => {
  const purchaseConditionsPrices = purchaseConditionsPricesBySimulation?.filter(
    (purchaseConditionsPrice) => purchaseConditionsPrice.id === skuId
  )

  if (purchaseConditionsPrices && purchaseConditionsPrices.length > 0) {
    const { id, listPrice, price } = purchaseConditionsPrices[0]

    return { id, listPrice, price }
  }

  return undefined
}
